export default {"src":"/_next/static/media/vk.762ac8f2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};